import { createReducer } from '@reduxjs/toolkit';
import { setUserDetailsLoading, setUserRecords } from './actions';
import type { UserDataModel } from './types';

interface UserState {
    records: Record<string, UserDataModel>;
    details: Record<string, { isLoading: boolean }>;
}

const initialState: UserState = { records: {}, details: {} };

export const usersReducer = createReducer<UserState>(initialState, (builder) => {
    builder
        .addCase(setUserRecords, (draft, action) => {
            action.payload.forEach((model) => {
                draft.records[model.id] = model;
            });
        })
        .addCase(setUserDetailsLoading, (draft, action) => {
            draft.details[action.payload.id] = action.payload;
        });
});
